import { httpGet } from "@eres/rest";
import cfg from "./config";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { I8N } from "@eres/core";
import { MSChargeDetails } from "./entities";
import { validateResponse as validateResponseX } from "@10x/dubai-rest-api/dist/entities";

export function loadMSChargeInvoices() {
	return httpGet( `${ cfg.mollakServiceChargeAPI().endPoint() }invoices` ).then( r => {
		return validateResponseX( r );
	} );
}

export function loadMSChargeDetails( propertyId: number ): Promise<MSChargeDetails> {
	return httpGet( `${ cfg.mollakServiceChargeAPI().endPoint() }?propertyId=${ propertyId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function loadMSChargeStatement( propertyId: number ): Promise<{ fileURL: string }> {
	return httpGet( `${ cfg.mollakServiceChargeAPI().endPoint() }statement?propertyId=${ propertyId }` ).then( r => {
		return validateResponse( r );
	} );
}

function validateResponse<T>( response: any ): Promise<T> {
	if ( response == undefined || response.response == undefined ) {
		return Promise.reject( "Empty response" );
	} else if ( response.ErrorMessage && !isEmptyStringOrNull( response.ErrorMessage.English ) &&
		!isEmptyStringOrNull( response.ErrorMessage.Arabic ) ) {
		let en = !isEmptyStringOrNull( response.ErrorMessage.English ) ? response.ErrorMessage.English : response.ErrorMessage.Arabic;
		let ar = !isEmptyStringOrNull( response.ErrorMessage.Arabic ) ? response.ErrorMessage.English : en;
		return Promise.reject( I8N.isRTL() ? ar : en );
	}
	return Promise.resolve( response.response );
}
